class LightboxModal {
    constructor() {
        document.addEventListener("DOMContentLoaded", () => {
            this.initModal();
        });
    }

    initModal() {
        this.galleryItems = Array.from(document.querySelectorAll(".lightbox-modal .wp-block-image img"));
        this.lightboxModal = this.createLightbox();
        this.currentIndex = 0;  // Initialize current index
        this.zoomLevel = 1;  // Initialize zoom level
        this.bindEvents();
    }

    createLightbox() {
        const lightbox = document.createElement("div");
        lightbox.className = "lightbox";
        lightbox.style.display = "none";
        lightbox.innerHTML = `
            <span class="image-counter">1/${this.galleryItems.length}</span>
            <span class="close-btn">&times;</span>
            <a class="prev">&#10094;</a>
            <a class="next">&#10095;</a>
            <div class="lightbox-content">
                <img class="lightbox-image" src="" alt="Lightbox Image" style="transform: scale(1); transform-origin: 0 0;">
            </div>
        `;
        document.body.appendChild(lightbox);
        this.imageCounter = lightbox.querySelector(".image-counter"); // Reference to the image counter
        this.lightboxImage = lightbox.querySelector(".lightbox-image"); // Reference to the image
        return lightbox;
    }

    bindEvents() {
        this.galleryItems.forEach((item, index) => {
            item.addEventListener("click", () => this.openModal(index));
        });

        this.lightboxModal.querySelector(".close-btn").addEventListener("click", () => this.closeModal());
        this.lightboxModal.querySelector(".prev").addEventListener("click", () => this.changeSlide(-1));
        this.lightboxModal.querySelector(".next").addEventListener("click", () => this.changeSlide(1));

        this.lightboxImage.addEventListener("click", (e) => {
            e.stopPropagation(); // Prevent modal close on image click
            this.toggleZoom();
        });

        this.lightboxImage.addEventListener("mousemove", (e) => {
            if (this.zoomLevel > 1) {
                this.adjustImagePosition(e);
            }
        });

        this.lightboxModal.addEventListener("click", (e) => {
            if (e.target === this.lightboxModal) {
                this.closeModal();
            }
        });
    }

    openModal(index) {
        this.currentIndex = index;
        const imgSrc = this.galleryItems[index].getAttribute("src");
        this.lightboxImage.src = imgSrc;
        this.imageCounter.textContent = `${index + 1}/${this.galleryItems.length}`; // Update counter
        this.resetZoom(); // Reset zoom on image change
        this.lightboxModal.style.display = "flex";
    }

    closeModal() {
        this.lightboxModal.style.display = "none";
        this.resetZoom(); // Reset zoom on close
    }

    changeSlide(direction) {
        this.currentIndex += direction;
        if (this.currentIndex >= this.galleryItems.length) {
            this.currentIndex = 0;
        } else if (this.currentIndex < 0) {
            this.currentIndex = this.galleryItems.length - 1;
        }
        this.openModal(this.currentIndex);
    }

    toggleZoom() {
        this.zoomLevel = this.zoomLevel === 1 ? 2 : 1;  // Toggle between 1x and 2x zoom
        this.lightboxImage.style.transform = `scale(${this.zoomLevel})`;
        this.lightboxImage.style.transformOrigin = '0 0'; // Reset transform origin
    }

    adjustImagePosition(e) {
        const rect = e.target.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const xPercent = x / rect.width * 100;
        const yPercent = y / rect.height * 100;
        this.lightboxImage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
    }

    resetZoom() {
        this.zoomLevel = 1;
        this.lightboxImage.style.transform = 'scale(1)';
        this.lightboxImage.style.transformOrigin = '0 0';
    }
}

export default LightboxModal;